import React from "react";
import { Form, Row, Col, Divider, Typography, Select, Descriptions, message } from "antd";
import { c_TipoDeRelación } from "../../../SATCatalogos/index";
import SelectFactura from "../../Inputs/SelectFactura";
import { getFactura, calcularImpuestosPComplementoPago, cambiarEquivalenciaDR } from "../services";
import Decimal from "decimal.js";

const { Title, Text } = Typography;
const { Option } = Select;

const RelacionTransaccionSection = (props) => {

    const { transaccionObj, clienteId } = props
    const form = Form.useFormInstance()

    //Al seleccionar una factura, la agregamos al array de DoctoRelacionado en el formulario
    const handleSelect = async (factura_id) => {
        try {
            let factura = await getFactura(factura_id);
            if(!factura) throw new Error("No se pudo obtener la factura seleccionada");

            const invoiceData = factura.request.invoice_data

            let facturaInfo = {
                IdDocumento: factura.uuid,
                Folio: invoiceData.Folio,
                Serie: invoiceData.Serie,
                MonedaDR: invoiceData.Moneda,
                MetodoDePagoDR: invoiceData.MetodoPago,
                NumParcialidad: "1",
                ImpSaldoAnt: invoiceData.Total,
                ImpPagado: invoiceData.Total,
                ImpSaldoInsoluto: "0.00",
                ObjetoImpDR: "01",
                EquivalenciaDR: "1"
            }

            //Si es un array
            if(Array.isArray(invoiceData?.Impuestos?.Traslados)){
                facturaInfo.ObjetoImpDR = "02" //Con impuestos trasladados

                const traslado = invoiceData.Impuestos.Traslados[0]

                facturaInfo.ImpuestosDR = {
                    TrasladosDR: [
                        {
                            BaseDR: traslado.Base,
                            ImpuestoDR: traslado.Impuesto,
                            TipoFactorDR: traslado.TipoFactor,
                            TasaOCuotaDR: traslado.TasaOCuota,
                            ImporteDR: traslado.Importe,
                            //ImporteDR: Decimal(traslado.Base).mul(Decimal(traslado.TasaOCuota)).toDecimalPlaces(6,Decimal.ROUND_DOWN).toString(),
                        }
                    ]
                }
            }

            //Si es un objeto
            if(invoiceData?.Impuestos?.Traslados["0"]?.Base){
                facturaInfo.ObjetoImpDR = "02" //Con impuestos trasladados

                const traslado = invoiceData.Impuestos.Traslados["0"]

                facturaInfo.ImpuestosDR = {
                    TrasladosDR: [
                        {
                            BaseDR: traslado.Base,
                            ImpuestoDR: traslado.Impuesto,
                            TipoFactorDR: traslado.TipoFactor,
                            TasaOCuotaDR: traslado.TasaOCuota,
                            ImporteDR: traslado.Importe,
                            //ImporteDR: Decimal(traslado.Base).mul(Decimal(traslado.TasaOCuota)).toDecimalPlaces(6,Decimal.ROUND_DOWN).toString(),
                        }
                    ]
                }
            }

            const doctoRelacionadoPath = [
                "Complemento",
                "Any",
                0,
                "Pago20:Pagos",
                "Pago",
                0,
                "DoctoRelacionado",
            ];

            const doctoRelacionadoActual = form.getFieldValue(doctoRelacionadoPath) || [];
            const existeDocumento = doctoRelacionadoActual.some(
                (item) => item?.IdDocumento === facturaInfo.IdDocumento
            );

            if (existeDocumento) {
                message.warning("Esta factura ya fue agregada en DoctoRelacionado");
                return;
            }

            form.setFields([
                {
                    name: doctoRelacionadoPath,
                    value: [...doctoRelacionadoActual, facturaInfo],
                },
            ]);

            const MonedaP = form.getFieldValue(["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "MonedaP"])
            cambiarEquivalenciaDR(form, transaccionObj.tipo_cambio, MonedaP)
            //cacular totales del complemento de pago
            calcularImpuestosPComplementoPago(form);
        } catch (error) {
            console.error("Error al obtener la factura relacionada:", error);
            message.error("Error al obtener la factura relacionada. Por favor, intente nuevamente.");
        }
    }

    //Al deseleccionar una factura, la quitamos del array de DoctoRelacionado en el formulario
    const handleDeselect = (factura_id, facturaObj) => {
        console.log("Factura a deseleccionar:", factura_id, facturaObj);
        const doctoRelacionadoPath = [
            "Complemento",
            "Any",
            0,
            "Pago20:Pagos",
            "Pago",
            0,
            "DoctoRelacionado",
        ];

        const doctoRelacionadoActual = form.getFieldValue(doctoRelacionadoPath) || [];
        const nuevoDoctoRelacionado = doctoRelacionadoActual.filter(
            (item) => item?.IdDocumento !== facturaObj.uuid
        );

        form.setFields([
            {
                name: doctoRelacionadoPath,
                value: nuevoDoctoRelacionado,
            },
        ]);

        //cacular totales del complemento de pago
        calcularImpuestosPComplementoPago(form);
    }

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Información de Transacción a relacionar</Title>
            </Row>
            <Form.Item name="transaccion_id" hidden/>
            <Row className="mb-1" gutter={[16, 16]}>
                <Col xs={20} md={12}>
                    <Descriptions column={2} size="small" bordered >
                        <Descriptions.Item label="Concepto">{transaccionObj.concepto}</Descriptions.Item>
                        <Descriptions.Item label="Monto">{`$ ${transaccionObj.monto.toLocaleString()}`}</Descriptions.Item>
                        <Descriptions.Item label="Monto Dolar">{`$ ${transaccionObj.monto_dolar.toLocaleString()}`}</Descriptions.Item>
                        <Descriptions.Item label="Fecha">{new Date(transaccionObj.createdAt).toLocaleDateString()}</Descriptions.Item>
                        <Descriptions.Item label="Cuenta">{transaccionObj.cuenta_id.nombre}</Descriptions.Item>
                    </Descriptions>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item 
                        name="facturas_ids" 
                        label="Factura a relacionar" 
                        rules={[{ required: false, message: "Seleccione la factura a relacionar" }]}
                    >
                        <SelectFactura
                            returnID={true} //en lugar del uuid, regresamos el _id
                            params={{
                                cliente_id: clienteId,
                                exep_tipo_comprobante: ["P"], //Quitar facturas de tipo P (Pago)
                            }}
                            placeholder="Seleccione la factura a relacionar"
                            onSelect={handleSelect}
                            onDeselect={handleDeselect}
                            allowClear={false}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default RelacionTransaccionSection;
